export default "__VITE_ASSET__EYRAMyam__"